import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import User from '@/views/User/models/user'

@Component({})
export default class VerifyBanner extends Mixins<MixinInterface>() {
    alert = true

    get mobileVerifyRequired() {
        return this.currentUser?.attributes.mobileNumberIsVerified == false
    }

    get emailVerifyRequired() {
        return this.currentUser?.attributes.primaryEmailIsVerified == false
    }

    @Watch('currentUser')
    init() {
        this.alert = this.mobileVerifyRequired || this.emailVerifyRequired
    }

    closeAlert() {
        this.alert = false
    }

    loading = false

    async verify(attr: 'mobileNumberIsVerified' | 'primaryEmailIsVerified') {
        this.loading = true

        await User.verify(attr, this.currentUser.id, this.currentUser.attributes.updatedAt, [
            'employer',
            'secondaryEmails',
        ])

        this.loading = false
    }
}
